import { GET_ALL_SKILLS_SUCCESS, GET_SKILL_LEVELS_SUCCESS } from '../actions/actionTypes';

export const skillsList = (state = [], action) => {
  switch (action.type) {
    case GET_ALL_SKILLS_SUCCESS:
      return action.skills;
    default:
      return state;
  }
};

export const skillLevels = (state = [], action) => {
  switch (action.type) {
    case GET_SKILL_LEVELS_SUCCESS:
      return action.skills;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/skills.js